import { Grid2 as Grid } from '@mui/material';
import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { Button, Labeled, NumberInput, TextField, TextInput, useInput } from 'react-admin';
import { ReactElement } from 'react';
import { APPROVAL_STATUS } from '../../utils';
import { ApprovalStatusField } from '../../ApprovalStatusField';

export default function ApprovalDetailsSection(props: Omit<Props, 'children'>): ReactElement {
  const { field } = useInput({ source: 'attributes.approval_status' });

  return (
    <AccordionForm.Panel defaultExpanded {...props}>
      <Grid container spacing={2} size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <Labeled label="ID" sx={{ mr: 2 }}>
            <TextField source="id" />
          </Labeled>
          <Labeled label="Name">
            <TextField source="attributes.name" />
          </Labeled>
        </Grid>
        <ApprovalStatusField />
        <Button
          disabled={field.value == APPROVAL_STATUS.APPROVED}
          label="Approve"
          onClick={() => field.onChange(`${APPROVAL_STATUS.APPROVED}`)}
          variant="contained"
        />
        <Button
          color="error"
          disabled={field.value == APPROVAL_STATUS.REJECTED}
          label="Reject"
          onClick={() => field.onChange(`${APPROVAL_STATUS.REJECTED}`)}
          variant="contained"
        />
        <NumberInput label="Bid CPC (cents)" source="attributes.bid_cents" />
        <TextInput label="Remarks" source="attributes.remarks" multiline />
      </Grid>
    </AccordionForm.Panel>
  );
}
